import { createApi } from '@reduxjs/toolkit/query/react';

import type { OTCResponseSchemaType, OTCSchemaType } from '@/global/schemas/otc.schema';

import { REDUX_SLICE } from '../constants';
import { axiosBaseQuery } from '../utils';

export const otcApi = createApi({
  reducerPath: REDUX_SLICE.OTC_API,
  tagTypes: ['OTCDetail'],
  baseQuery: axiosBaseQuery,
  endpoints: builder => ({
    getOTCDetail: builder.query<OTCSchemaType, { programId?: string; creator?: string; otcId: string }>({
      query: ({ programId, otcId }) => ({
        path: `/v1/programs/${programId}/deals/${otcId}`,
        headers: {
          'x-nodesale-lang': 'en',
        },
      }),
      transformResponse: (returnValue: OTCResponseSchemaType) => {
        return returnValue.data;
      },
      providesTags: (_result, _error, arg) => [{ type: 'OTCDetail', programId: arg.programId, id: arg.otcId }],
    }),
  }),
});

export const { useGetOTCDetailQuery } = otcApi;
